import { useHistory } from 'react-router';
import { useCallback } from 'react';

import { UserSettingsRoutesConfig } from 'domains/userSettings/Routes';
import { selectAccounts } from 'modules/account/store/selectors';
import { useAppSelector } from 'store/useAppSelector';
import { useIsAccountCreationAllowedQuery } from 'modules/teamAccount/actions/hooks/useIsAccountCreationAllowedQuery';
import { useTeamAccountsQuery } from 'modules/teamAccount/actions/hooks/useTeamAccountsQuery';

import { useSignOutHandler } from './useSignOutHandler';

const settingsPath = UserSettingsRoutesConfig.settings.generatePath();

export interface IUseAccountsMenuProps {
  isAccountsMenuOpened: boolean;
  onClose: () => void;
}

export const useAccountsMenu = ({
  isAccountsMenuOpened,
  onClose,
}: IUseAccountsMenuProps) => {
  const { signOut } = useSignOutHandler();

  const { push } = useHistory();

  const skipFetching = !isAccountsMenuOpened;

  const { loading: accountsLoading } = useTeamAccountsQuery({ skipFetching });

  const { isAccountCreationAllowed } = useIsAccountCreationAllowedQuery({
    skipFetching,
  });

  const accounts = useAppSelector(selectAccounts);

  const handleGoToSettings = useCallback(() => {
    push(settingsPath);
    onClose();
  }, [onClose, push]);

  return {
    accounts,
    accountsLoading,
    handleGoToSettings,
    isAccountCreationAllowed,
    signOut,
  };
};
